import { Component, SyntheticEvent } from "react";
import { Dialog } from "../../components/dialogs/Dialog";
import { EmployeeTable } from "../../components/table/EmployeeTable";
import { withLocale, WithLocaleProps } from "../../providers/LocaleProvider";

interface GroupMembersDialogProps extends WithLocaleProps {
  theme?: any;
  employees?: any[];
  onCancel?: (e: SyntheticEvent) => void;
}

class GroupMembersDialogBase extends Component<GroupMembersDialogProps> {
  render() {
    const { theme, employees, onCancel, translate } = this.props;

    return (
      <Dialog
        open={true}
        onClose={onCancel}
        theme={theme}
        fullWidth={true}
        title={translate("dialogs.groupMembers")}
        maxWidth='sm'
        actions={[
          {
            label: translate("common.close"),
            primary: true,
            onClick: onCancel
          }
        ]}
      >
        <EmployeeTable
          translate={translate}
          pagination={false}
          showFooter={false}
          rowHasAction={true}
          theme={theme}
          showHeaderFromBreakpoint='md'
          dense={true}
          columns={[
            { type: EmployeeTable.columns.fullName },
            { type: EmployeeTable.columns.jobTitle }
          ]}
          sortModel={[
            {
              field: "fullName",
              sort: "asc"
            }
          ]}
          paper={false}
          rows={employees}
          sx={{ maxHeight: "400px" }}
        />
      </Dialog>
    );
  }
}

export const GroupMembersDialog = withLocale(GroupMembersDialogBase);
